import PageHeader from "@/components/PageHeader";
import ProfileForm from "@/components/ProfileForm";

const GROUPS = [
  {
    title: "Intressen och drivkrafter",
    fields: [
      { name: "interests", label: "Intressen och hobbies", type: "tags", full: true, placeholder: "Skriv och tryck Enter" },
      { name: "areas", label: "Vad engagerar dig?", type: "tags", full: true, placeholder: "T.ex. teknik, natur, hälsa, kultur, företagande, människor, kreativitet" },
    ],
  },
  {
    title: "Lärande och nyfikenhet",
    fields: [
      { name: "learning", label: "Vad vill du lära dig mer om?", type: "textarea", full: true },
      { name: "curiosity", label: "Vad är du nyfiken på just nu?", type: "textarea", full: true },
    ],
  },
  {
    title: "Framtid",
    fields: [
      { name: "future_plans", label: "Framtidsplaner", type: "textarea", full: true },
      { name: "develop", label: "Vad vill du utveckla hos dig själv?", type: "textarea", full: true },
    ],
  },
];

export default function Intressen() {
  return (
    <div>
      <PageHeader title="Intressen och drivkrafter" description="Berätta om det som engagerar och driver dig – både på och utanför jobbet." />
      <ProfileForm groups={GROUPS} endpoint="/profile/interests" loadKey="interests" />
    </div>
  );
}
